import React, { useState } from "react"
import styles from "./index.module.scss"
// import { Order } from "../OrderTable"
import TrashIcon from "../../../../../assets/icons/TrashIcon"
import ConfigIcon from "../../../../../assets/icons/ConfigIcon"
import { DragAndDropIcon } from "../../../../../assets/icons/DragAndDrop"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { ArrowDownRed } from "../../../../../assets/icons/ArrowDownRed"
import { ArrowUpGreen } from "../../../../../assets/icons/ArrowUpGreen"
import intl from "react-intl-universal"
import { set } from "react-hook-form"
import { toast } from "@stardust-ds/react"

function TableComponent({
  thead,
  tbodyArray,
  setTableBodyArray,
  handleClickSettings,
  handleClickRemoveAnalyteLinked,
  cursorNormal = false,
  cTextNoData = "Não há dados.",
  setEqpAnalytes,
  eqp_analytes,
  bControl = false,
  setIsChanged,
  messageWarning,
}) {
  if (!tbodyArray || tbodyArray.length === 0) {
    return (
      <>
        <table className={styles.table}>
          <thead className={styles.head}>
            <tr>
              {thead.map((item, index, array) => (
                <th
                  className="th"
                  key={index}
                  style={{
                    textAlign: item === "Ações" ? "center" : "left",
                  }}
                >
                  <span className={styles.noText}>{item}</span>
                </th>
              ))}
            </tr>
          </thead>
        </table>
        <p className={styles.textNoData}>{cTextNoData}</p>
      </>
    )
  }
  const columns = Object?.keys(tbodyArray[0])

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    // Update the order of your data based on the result.
    const reorderedData = Array.from(tbodyArray)
    const [removed] = reorderedData.splice(result.source.index, 1)
    reorderedData.splice(result.destination.index, 0, removed)

    const data = reorderedData.map((item, index) => ({ ...item, eqpanlt_norder: index }))

    setTableBodyArray(data)

    const sendReorder = reorderedData.map((item, index) => {
      const eqpanalyte = eqp_analytes.find(
        (eqpanalyte) => eqpanalyte.eqpanlt_anlt_nid === item.anlt_nid,
      )

      return {
        eqpanlt_anlt_nid: item.anlt_nid,
        eqpanlt_bstatus: eqpanalyte.eqpanlt_bstatus,
        eqpanlt_norder: index,
      }
    })

    setEqpAnalytes(sendReorder)
    setIsChanged(true)
  }

  const fnHandleStringManipulation = (info) => {
    if (typeof info === "string") {
      const information = info?.split(/(\s+)/)
      return information.map((inf, index) => (
        <React.Fragment key={index}>
          {inf === "<icon-high>" && <ArrowUpGreen />}
          {inf === "<icon-low>" && <ArrowDownRed />}
          {inf !== "<icon-high>" && inf !== "<icon-low>" && inf}
        </React.Fragment>
      ))
    }
  }

  function fnOpenToastFail(message) {
    return toast({
      type: "warning",
      title: "Alerta",
      description: message,
    })
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className={styles.containerTable}>
        <table className={styles.table}>
          <thead className={styles.head}>
            <tr>
              {thead.map((item, index) => (
                <th
                  className="th"
                  key={index}
                  style={{
                    width:
                      (bControl && item.includes("Actions")) || item.includes("Ações")
                        ? "normal"
                        : "max-content",
                  }}
                >
                  <span style={{ color: "#737d86 !important" }}>{item}</span>
                </th>
              ))}
            </tr>
          </thead>
          <Droppable droppableId="table-linked">
            {(provided) => (
              <tbody
                className={styles.tableBody}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {tbodyArray.map((item, rowIndex) => (
                  <Draggable
                    key={`equipment-analyte-${rowIndex}`}
                    draggableId={`${rowIndex}`}
                    index={rowIndex}
                  >
                    {(provided) => (
                      <tr
                        key={rowIndex}
                        style={{
                          cursor: cursorNormal ? "default" : "pointer",
                          ...provided.draggableProps.style,
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {columns
                          .filter(
                            (item) =>
                              !item.includes("id") &&
                              !item.includes("eqpanlt") &&
                              !item.includes("anlt_result_options") &&
                              !item.includes("anlt_bstatus"),
                          )
                          .map((column, columnIndex) => {
                            return (
                              <td
                                key={columnIndex}
                                className={`${styles.td} ${
                                  (column.includes("name") ||
                                    column.includes("observation")) &&
                                  styles.cname
                                } 
                                `}
                              >
                                {column.includes("status") ? (
                                  <span
                                    className={`${
                                      item[column] ? styles.ativo : styles.inativo
                                    }`}
                                    style={{ textTransform: "capitalize !important" }}
                                  >
                                    {item[column]
                                      ? intl.get("ciq.list_analytes.active")
                                      : intl.get("ciq.list_analytes.inactive")}
                                  </span>
                                ) : item[column]?.length === 0 ||
                                  item[column] === null ? (
                                  " - "
                                ) : column.includes("name") ? (
                                  <>
                                    <DragAndDropIcon
                                      style={{ marginRight: "1rem", cursor: "grab" }}
                                    />
                                    {item[column]}
                                  </>
                                ) : (
                                  <>{fnHandleStringManipulation(item[column])}</>
                                )}
                              </td>
                            )
                          })}

                        <td>
                          <div className={`${styles.containerAction} `}>
                            <div
                              className={`${styles.icon} ${styles.configIcon}`}
                              onClick={() => {
                                const object = Object.keys(item).length

                                if (object < 10) {
                                  if (bControl) {
                                    fnOpenToastFail(
                                      intl.get(
                                        "ciq.toas_warning_edit_analyte_in_control",
                                      ),
                                    )
                                  } else {
                                    fnOpenToastFail(
                                      intl.get(
                                        "ciq.toas_warning_edit_analyte_in_eqpment",
                                      ),
                                    )
                                  }
                                  return
                                } else {
                                  handleClickSettings(item)
                                }
                              }}
                            >
                              <ConfigIcon fill={"#737D86"} />
                            </div>
                            <div
                              className={`${styles.icon} ${styles.trashIcon}`}
                              onClick={() => {
                                handleClickRemoveAnalyteLinked(item)
                              }}
                            >
                              <TrashIcon fill="red" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </table>
      </div>
    </DragDropContext>
  )
}

export const TableLinkAnalytes = React.memo(TableComponent)
